import { Component } from "react";
import React from "react";
import JobApplicationEntity from "../../types/jobApplicationEntity.type";

type Props = {
  listItems: JobApplicationEntity[];
  onEdit: (jobApplication: JobApplicationEntity) => void;
  onDelete: (jobApplicationId: number) => void;
};

export default class JobApplicationsList extends Component<Props> {
  render() {
    console.log("JobApplicationsList listItems:", this.props.listItems); // Debug props
    const listItems = this.props.listItems.map((item) => (
      <tr key={item.id ?? Math.random()}>
        <td scope="row">{item.id ?? "N/A"}</td>
        <td>{item.job ?? "N/A"}</td>
        <td>{item.userId ?? "N/A"}</td>
        <td>{item.approved != null ? (item.approved ? "Yes" : "No") : "N/A"}</td>
        <td>{item.createdAt ?? "N/A"}</td>
        <td>{item.updatedAt ?? "N/A"}</td>
        <td>
          <button
            onClick={() => {
              console.log("Edit button clicked for job application:", item); // Debug
              this.props.onEdit(item);
            }}
            className="btn btn-primary btn-sm"
            disabled={item.id == null}
          >
            Edit
          </button>
          <button
            onClick={() => {
              console.log("Delete button clicked for job application ID:", item.id); // Debug
              item.id != null && this.props.onDelete(item.id);
            }}
            className="btn btn-danger btn-sm"
            disabled={item.id == null}
          >
            Delete
          </button>
        </td>
      </tr>
    ));

    return (
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Job Application ID</th>
            <th>Job ID</th>
            <th>Job Poster ID</th>
            <th>Approved Application</th>
            <th>Created</th>
            <th>Updated</th>
            <th>Modify</th>
          </tr>
        </thead>
        <tbody>{listItems}</tbody>
      </table>
    );
  }
}
